(() => {
  if (customElements.get('products-carousel')) {
    return;
  }

  class ProductsCarousel extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {
        navigation: {
          prevEl: '.swiper-arrow--prev',
          nextEl: '.swiper-arrow--next',
        },
        slidesPerView: 2,
        centeredSlides: true,
        initialSlide: 1,
        spaceBetween: 20,
        breakpoints: {
          750: {
            slidesPerView: 4,
            centeredSlides: false,
            initialSlide: 0
          }
        }
      };

      if (this.autoplay === 'true') {
        this.options.autoplay = {
          delay: this.dataset.autoplaySpeed,
        };
      }
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.querySelector('[data-slider]')) return;

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options
      );
    }
  }

  customElements.define('products-carousel', ProductsCarousel);
})();
